import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Disclaimer from './components/Disclaimer';
import Dashboard from './pages/Dashboard';
import LogEntry from './pages/LogEntry';
import Entries from './pages/Entries';
import Insights from './pages/Insights';
import Appointments from './pages/Appointments';
import AdminPanel from './pages/AdminPanel';
import Login from './pages/Login';
import Register from './pages/Register';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          <Route path="/*" element={
            <div className="min-h-screen">
              <Disclaimer />
              <Navbar />
              <main className="container mx-auto px-4 py-8">
                <Routes>
                  <Route path="/" element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  } />
                  <Route path="/log" element={
                    <PrivateRoute>
                      <LogEntry />
                    </PrivateRoute>
                  } />
                  <Route path="/entries" element={
                    <PrivateRoute>
                      <Entries />
                    </PrivateRoute>
                  } />
                  <Route path="/insights" element={
                    <PrivateRoute>
                      <Insights />
                    </PrivateRoute>
                  } />
                  <Route path="/appointments" element={
                    <PrivateRoute>
                      <Appointments />
                    </PrivateRoute>
                  } />
                  <Route path="/admin" element={
                    <PrivateRoute adminOnly={true}>
                      <AdminPanel />
                    </PrivateRoute>
                  } />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
            </div>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;